<template>
    <div>
        <el-form ref="pfForm" :model="pfForm">
            <div class="xzrTd" style="width: 1300px;">
                <tr height="20" style='height:30.00pt;'>
                </tr>
                <tr height="26.67" style='height:20.00pt;mso-height-source:userset;mso-height-alt:400;'>
                    <td class="xzr65" height="53.33" rowspan="2"
                        style='height:40.00pt;border-right:.5pt solid windowtext;border-bottom:.5pt solid windowtext;width: 100px;min-width: 46px;'
                        x:str>序号
                    </td>
                    <td class="xzr66" rowspan="2"
                        style='border-right:.5pt solid windowtext;border-bottom:.5pt solid windowtext;min-width: 126px;'
                        x:str>评价项目</td>
                    <td class="xzr661" rowspan="2"
                        style='border-right:.5pt solid windowtext;border-bottom:.5pt solid windowtext;min-width: 341px;'
                        x:str>评价指标</td>
                    <td class="xzr67" colspan="4"
                        style='border-right:.5pt solid windowtext;border-bottom:.5pt solid windowtext;' x:str>评分标准</td>
                    <td class="xzr68" :colspan="tableData.teaData.length" x:str>教师姓名(课程)</td>
                    <td class="xzr77"></td>
                </tr>
                <tr height="26.67" style='height:20.00pt;mso-height-source:userset;mso-height-alt:400;'>
                    <td class="xzr711" style="min-width: 57px;" x:str>优</td>
                    <td class="xzr712" style="min-width: 57px;" x:str>良</td>
                    <td class="xzr713" style="min-width: 57px;" x:str>中</td>
                    <td class="xzr714" style="min-width: 57px;" x:str>差</td>
                    <template v-for="(item,row) in tableData.teaData">
                        <td class="xzr72" x:str>{{item.teaName}}<br />({{parseCourseName(item.courseName)}})</td>
                    </template>
                    <td class="xzr77"></td>
                </tr>

                <template v-for="(item,row) in tableData.pjxData">
                    <tr height="53.33" style='height:40.00pt;mso-height-source:userset;mso-height-alt:800;'>
                        <td class="xzr73" height="53.33" style='height:40.00pt;' x:num>{{item.xh}}</td>
                        <td class="xzr74" x:str>{{item.pjxmc}}<br />(<span v-html="item.qz" />)</td>
                        <td class="xzr75" x:str>{{item.pjxnr}}</td>
                        <td class="xzr991" x:str>
                            <div v-html="item.y" />
                        </td>
                        <td class="xzr992" x:str>
                            <div v-html="item.l" />
                        </td>
                        <td class="xzr993" x:str>
                            <div v-html="item.z" />
                        </td>
                        <td class="xzr994" x:str>
                            <div v-html="item.c" />
                        </td>

                        <template v-for="(itemB,column) in tableData.teaData">
                            <td class="xzr76" x:num>
                                <el-form-item :prop="'pfArr['+row+']['+column+']'"
                                    :rules="[{required: true, message: ' '}]">
                                    <el-input-number v-model="pfForm.pfArr[row][column]" size="mini" :min="0"
                                        :max="sfzr(row,column,tableData.pjxData[row],tableData.teaData[column].sfzr)"
                                        @input="changePf($event,item.bh,tableData.teaData[column].teaCode,row,column,tableData.teaData[column].courseName,tableData.teaData[column].courseCode,sfzr(row,column,tableData.pjxData[row],tableData.teaData[column].sfzr))">
                                    </el-input-number>
                                </el-form-item>
                            </td>
                        </template>
                        <td class="xzr77"></td>
                    </tr>
                </template>

                <tr height="20" style='height:30.00pt;'>
                </tr>
            </div>
        </el-form>
    </div>
</template>

<script>
    import {
        confirmMsg,
        showNotify
    } from "utils/message";

    export default {
        props: ['xzrCode', 'type', 'semesterCode'],
        data() {
            return {
                tableData: {
                    pjxData: [],
                    teaData: [],
                },

                pfForm: {
                    pfArr: []
                },
                qzArr: [],
                dfArr: [],
                loadingMask:null
            };
        },
        mounted() {
            this.queryTableData()
        },
        methods: {
            parseCourseName(str){
                let split = str.split("、");
                let set = new Set();
                split.forEach(item=>{
                    set.add(item)
                })
                str = "";
                set.forEach(item=>{
                    str += item + "、"
                })
                return str.substring(0, str.length - 1);
            },
            showLoadingMask(str) {
                this.loadingMask = this.$loading({
                    lock: true,
                    text: str,
                    spinner: "el-icon-loading",
                    background: "rgba(0, 0, 0, 0.8)",
                });
            },
            /**关闭loading**/
            closeLoadingMask() {
                if (this.loadingMask) this.loadingMask.close();
            },
            //判断是否为专任教师
            sfzr(row, column, pjxData, teaState) {
                if (pjxData.qz.indexOf("教师") != -1) {
                    if (teaState == '1') {
                        //专任教师
                        return parseInt(pjxData.zrjs);
                    } else {
                        //非专任教师
                        return parseInt(pjxData.fzrjs);
                    }
                }
                return parseInt(pjxData.qz);
            },
            //提交问卷
            submit() {
                this.$refs["pfForm"].validate((valid) => {
                    if (valid) {
                        confirmMsg('提交后无法修改,是否确定提交?').then(() => {
                            this.showLoadingMask('提交中，请稍候...')
                            let sub = [];
                            for (var i = 0; i < this.dfArr.length; i++) {
                                for (var j = 0; j < this.dfArr[i].length; j++) {
                                    sub.push(this.dfArr[i][j])
                                }
                            }

                            let formData = new FormData();
                            formData.append('type', this.type);
                            formData.append('semesterCode', this.semesterCode)
                            formData.append('cjr', this.xzrCode)
                            formData.append('list', sub)

                            this.$api.evaluateManage.questionnaireServer.subXzrEvaluate({
                                    data: formData
                                })
                                .then((res) => {
                                    let state = res.data.data;
                                    switch (state) {
                                        case 'Success':
                                            // showNotify('成功', '提交成功', 'success', 1500);
                                            location.reload();
                                            break;
                                        default:
                                            this.closeLoadingMask()
                                            showNotify('错误', '提交失败', 'error', 3000);
                                            break;
                                    }
                                }).catch((err) => {
                                this.closeLoadingMask()
                                    console.log(err);
                                });

                        });

                    } else {
                        return false;
                    }
                });

            },
            //修改评分
            changePf(event, pjxBh, teaCode, row, column, courseName, courseCode, qz) {
                let str = "";
                str = pjxBh + "@" + teaCode + "@" + event + "@" + courseName + "@" + courseCode + "@" + qz;
                this.dfArr[row][column] = str
            },
            queryTableData() {
                //评价项数据
                this.$api.evaluateManage.questionnaireServer.pjxData({
                        data: this.type
                    })
                    .then((res) => {
                        this.tableData.pjxData = res.data.data

                        //教师信息
                        let formData = new FormData();
                        formData.append('xzrCode', this.xzrCode);
                        formData.append('semesterCode', this.semesterCode)
                        this.$api.evaluateManage.questionnaireServer.xzrTeaData({
                                data: formData
                            })
                            .then((res) => {
                                this.tableData.teaData = res.data.data

                                var pf = [];
                                var qz = [];
                                var df = [];
                                for (var i = 0; i < this.tableData.pjxData.length; i++) {
                                    pf[i] = [];
                                    qz[i] = [];
                                    df[i] = [];

                                    for (var j = 0; j < this.tableData.teaData.length; j++) {
                                        pf[i][j] = undefined;
                                        df[i][j] = undefined;
                                        qz[i][j] = parseInt(this.tableData.pjxData[i].qz);
                                    }
                                }
                                this.pfForm.pfArr = pf;
                                this.qzArr = qz;
                                this.dfArr = df;

                            }).catch((err) => {
                                console.log(err);
                            });
                    }).catch((err) => {
                        console.log(err);
                    });

            }
        },
    };
</script>

<style>
    .styleXzr {
        mso-number-format: "General";
        text-align: general;
        vertical-align: middle;
        white-space: nowrap;
        mso-rotate: 0;
        color: windowtext;
        font-size: 12.0pt;
        font-weight: 400;
        font-style: normal;
        text-decoration: none;
        font-family: 宋体;
        mso-font-charset: 134;
        border: none;
        mso-protection: locked visible;
        mso-style-name: "常规";
        mso-style-id: 0;
    }

    .xzrTd {
        mso-style-parent: styleXzr;
        padding-top: 1px;
        padding-right: 1px;
        padding-left: 1px;
        mso-ignore: padding;
        mso-number-format: "General";
        text-align: general;
        vertical-align: middle;
        white-space: nowrap;
        mso-rotate: 0;
        color: windowtext;
        font-size: 12.0pt;
        font-weight: 400;
        font-style: normal;
        text-decoration: none;
        font-family: 宋体;
        mso-font-charset: 134;
        border: none;
        mso-protection: locked visible;

        overflow: auto;
        width: 100%;
    }

    .xzr65 {
        mso-style-parent: styleXzr;
        text-align: center;
        font-weight: 700;
        mso-generic-font-family: auto;
        mso-font-charset: 134;
        border-left: 1.0pt solid windowtext;
        border-top: 1.0pt solid windowtext;
        border-right: .5pt solid windowtext;
        border-bottom: .5pt solid windowtext;

        position: sticky;
        left: 0;
        background-color: #ffffff;
    }

    .xzr66 {
        mso-style-parent: styleXzr;
        text-align: center;
        font-weight: 700;
        mso-generic-font-family: auto;
        mso-font-charset: 134;
        border-left: .5pt solid windowtext;
        border-top: 1.0pt solid windowtext;
        border-right: .5pt solid windowtext;
        border-bottom: .5pt solid windowtext;

        position: sticky;
        left: 46px;
        background-color: #ffffff;
    }

    .xzr661 {
        mso-style-parent: styleXzr;
        text-align: center;
        font-weight: 700;
        mso-generic-font-family: auto;
        mso-font-charset: 134;
        border-left: .5pt solid windowtext;
        border-top: 1.0pt solid windowtext;
        border-right: .5pt solid windowtext;
        border-bottom: .5pt solid windowtext;

        position: sticky;
        left: 172px;
        background-color: #ffffff;
    }

    .xzr67 {
        mso-style-parent: styleXzr;
        text-align: center;
        font-weight: 700;
        mso-font-charset: 134;
        border-left: .5pt solid windowtext;
        border-top: 1.0pt solid windowtext;
        border-right: .5pt solid windowtext;
        border-bottom: .5pt solid windowtext;

        position: sticky;
        left: 513px;
        background-color: #ffffff;
    }

    .xzr68 {
        mso-style-parent: styleXzr;
        text-align: center;
        font-weight: 700;
        mso-generic-font-family: auto;
        mso-font-charset: 134;
        border-left: .5pt solid windowtext;
        border-top: 1.0pt solid windowtext;
        border-right: 1.0pt solid windowtext;
        border-bottom: .5pt solid windowtext;
    }

    .xzr69 {
        mso-style-parent: styleXzr;
        text-align: center;
        font-weight: 700;
        mso-font-charset: 134;
        border-left: 1.0pt solid windowtext;
        border-top: .5pt solid windowtext;
        border-right: .5pt solid windowtext;
        border-bottom: .5pt solid windowtext;
    }

    .xzr70 {
        mso-style-parent: styleXzr;
        text-align: center;
        font-weight: 700;
        mso-font-charset: 134;
        border: .5pt solid windowtext;
    }

    .xzr711 {
        mso-style-parent: styleXzr;
        text-align: center;
        mso-font-charset: 134;
        border: .5pt solid windowtext;

        position: sticky;
        left: 513px;
        background-color: #ffffff;
    }

    .xzr712 {
        mso-style-parent: styleXzr;
        text-align: center;
        mso-font-charset: 134;
        border: .5pt solid windowtext;

        position: sticky;
        left: 570px;
        background-color: #ffffff;
    }

    .xzr713 {
        mso-style-parent: styleXzr;
        text-align: center;
        mso-font-charset: 134;
        border: .5pt solid windowtext;

        position: sticky;
        left: 627px;
        background-color: #ffffff;
    }

    .xzr714 {
        mso-style-parent: styleXzr;
        text-align: center;
        mso-font-charset: 134;
        border: .5pt solid windowtext;

        position: sticky;
        left: 684px;
        background-color: #ffffff;
    }

    .xzr72 {
        mso-style-parent: styleXzr;
        text-align: center;
        white-space: normal;
        mso-font-charset: 134;
        border-left: .5pt solid windowtext;
        border-top: .5pt solid windowtext;
        border-right: 1.0pt solid windowtext;
        border-bottom: .5pt solid windowtext;

        white-space: normal;
        width: 10%;


        /* left: 741px; */
        background-color: #ffffff;
    }

    .xzr73 {
        mso-style-parent: styleXzr;
        text-align: center;
        mso-font-charset: 134;
        border-left: 1.0pt solid windowtext;
        border-top: .5pt solid windowtext;
        border-right: .5pt solid windowtext;
        border-bottom: 1.0pt solid windowtext;

        position: sticky;
        left: 0;
        background-color: #ffffff;
        z-index: 99;
    }

    .xzr74 {
        mso-style-parent: styleXzr;
        text-align: center;
        white-space: normal;
        mso-font-charset: 134;
        border-left: .5pt solid windowtext;
        border-top: .5pt solid windowtext;
        border-right: .5pt solid windowtext;
        border-bottom: 1.0pt solid windowtext;

        position: sticky;
        left: 46px;
        background-color: #ffffff;
        z-index: 99;
    }

    .xzr991 {
        mso-style-parent: styleXzr;
        text-align: center;
        white-space: normal;
        mso-font-charset: 134;
        border-left: .5pt solid windowtext;
        border-top: .5pt solid windowtext;
        border-right: .5pt solid windowtext;
        border-bottom: 1.0pt solid windowtext;
        font-size: 10px;

        position: sticky;
        left: 513px;
        background-color: #ffffff;
        z-index: 99;
    }

    .xzr992 {
        mso-style-parent: styleXzr;
        text-align: center;
        white-space: normal;
        mso-font-charset: 134;
        border-left: .5pt solid windowtext;
        border-top: .5pt solid windowtext;
        border-right: .5pt solid windowtext;
        border-bottom: 1.0pt solid windowtext;
        font-size: 10px;

        position: sticky;
        left: 570px;
        background-color: #ffffff;
        z-index: 99;
    }

    .xzr993 {
        mso-style-parent: styleXzr;
        text-align: center;
        white-space: normal;
        mso-font-charset: 134;
        border-left: .5pt solid windowtext;
        border-top: .5pt solid windowtext;
        border-right: .5pt solid windowtext;
        border-bottom: 1.0pt solid windowtext;
        font-size: 10px;

        position: sticky;
        left: 627px;
        background-color: #ffffff;
        z-index: 99;
    }

    .xzr994 {
        mso-style-parent: styleXzr;
        text-align: center;
        white-space: normal;
        mso-font-charset: 134;
        border-left: .5pt solid windowtext;
        border-top: .5pt solid windowtext;
        border-right: .5pt solid windowtext;
        border-bottom: 1.0pt solid windowtext;
        font-size: 10px;

        position: sticky;
        left: 684px;
        background-color: #ffffff;
        z-index: 99;
    }

    .xzr75 {
        mso-style-parent: styleXzr;
        text-align: left;
        mso-font-charset: 134;
        border-left: .5pt solid windowtext;
        border-top: .5pt solid windowtext;
        border-right: .5pt solid windowtext;
        border-bottom: 1.0pt solid windowtext;
        white-space: normal;

        position: sticky;
        left: 172px;
        background-color: #ffffff;
        z-index: 99;
    }

    .xzr76 {
        mso-style-parent: styleXzr;
        text-align: center;
        mso-font-charset: 134;
        border-left: .5pt solid windowtext;
        border-top: .5pt solid windowtext;
        border-right: 1.0pt solid windowtext;
        border-bottom: 1.0pt solid windowtext;

        min-width: 160px;

        background-color: #ffffff;
        z-index: 1;
    }

    .xzr77 {
        border-left: .5pt solid windowtext;

        position: sticky;
        right: -1px;
        background-color: #ffffff;
        z-index: 99;
    }


    /** -------------------------------- **/
/*    .sticky-table {
        overflow: auto;
        width: 100%;
    } */

    /** -------------------------------- **/
</style>



// WEBPACK FOOTER //
// xzrEvaluate.vue?f2fb9908